import { COLOR_PALETTE } from '@brightdrop/mui-theme-override';
import { makeStyles } from 'tss-react/mui';

export type FeedbackStarDisplayMode = 'empty' | 'gold' | 'green';

/**
 * Star shape comes from `feedback-star.svg`. `empty` is outline-only; `filled`
 * uses theme success (green) or palette gold when `displayMode` is not `empty`.
 */
const useFeedbackStarIconStyles = makeStyles<{
  displayMode: FeedbackStarDisplayMode;
}>()((theme, { displayMode }) => {
  const filledColor =
    displayMode === 'green'
      ? (theme.new.color.success[600] as string)
      : displayMode === 'gold'
        ? COLOR_PALETTE.common.gold
        : undefined;

  return {
    root: {
      lineHeight: 0,
      display: 'inline-flex',
      flexShrink: 0,
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box',
    },
    empty: {
      color: 'inherit',
      '& path': {
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: 1.4,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
      },
    },
    filled:
      filledColor === undefined
        ? {}
        : {
            color: filledColor,
            '& path': {
              fill: filledColor,
              stroke: filledColor,
              strokeWidth: 2,
              strokeLinecap: 'round' as const,
              strokeLinejoin: 'round' as const,
            },
          },
  };
});

export default useFeedbackStarIconStyles;
